import _ from 'lodash';
_.noConflict();

export default {
  props: {
    errorGetter: {
      type: Function,
      default: () => () => {}
    },
    errorPath: { // path is path in object like `options.rules.1.conditions.1.values`
      type: String,
      default: ''
    },
    errorObject: {
      type: Object,
      default: null
    },

    // TODO: dirty hack, all error wrappers must work with this flag as true
    frontendValidation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _errorGetter () {
      if (this.errorObject) {
        return f => _.get(this.errorObject, f, '');
      }
      return this.errorGetter;
    }
  }
};
